import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-careers',
  templateUrl: './careers.component.html',
  styleUrls: ['./careers.component.scss']
})
export class CareersComponent implements OnInit {

  constructor(private titleService: Title, private metaService: Meta) { }

  ngOnInit() {
    this.titleService.setTitle('Careers at GOLDOL Lubricants - Join Our Team');
    this.metaService.updateTag({ name: 'description', content: 'Explore exciting career opportunities at GOLDOL Lubricants. Join our team and be a part of the leading oil and lubricants manufacturer in the UAE.' });
    this.metaService.updateTag({ name: 'keywords', content: 'lubricant oil suppliers dubai' });
  }

}
